module.exports = __webpack_public_path__ + "static/img/til56.ed2cb5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til56.png
// module id = fK4v
// module chunks = 1